import moment from "moment";

const parseDate = (date) => {
  const year = date.getFullYear();
  let month = (date.getMonth() + 1) + "";
  month = (month<10)? "0"+month : month;
  let day = date.getDate()+"";
  day = (day<10)? "0"+day : day;
  return year+"-"+month+"-"+day;
};

const formatTimestamp = (timestampString) => {
  var date = moment(timestampString);
  return date.format("HH:mm DD.MM.YYYY");
};

const formatTimestamps = (timestampString1, timestampString2) => {
  var date1 = moment(timestampString1);
  var date2 = moment(timestampString2);

  if(!timestampsDatesDifferent(timestampString1, timestampString2)){
    return [
      date1.format("HH:mm"),
      date2.format("HH:mm"),
    ];
  }

  return [
    date1.format("HH:mm DD.MM.YYYY"),
    date2.format("HH:mm DD.MM.YYYY"),
  ];
};

const timestampsDatesDifferent = (timestampString1, timestampString2) => {
  var date1 = moment(timestampString1);
  var date2 = moment(timestampString2);

  return date1.format("DD.MM.YYYY")!==date2.format("DD.MM.YYYY");

};

export {parseDate, formatTimestamp, formatTimestamps, timestampsDatesDifferent};
export default parseDate;